import { render, staticRenderFns } from "./MovingArrow.vue?vue&type=template&id=1e4fb40f"
import script from "./MovingArrow.vue?vue&type=script&lang=js"
export * from "./MovingArrow.vue?vue&type=script&lang=js"
import style0 from "./MovingArrow.vue?vue&type=style&index=0&id=1e4fb40f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports